import { isNil } from '../util.js';
import { ensureTracker, findHandsUPPostId, findOneSevenStreamId } from '../runtime.js';

/**
 * @type {(skuId: string | number) => Promise<void>}
 * @deprecated This function has been replaced by `trackHandsupProductClickEvent`
 * 盤查後，目前只有在 handsup-cms-sdk 專案中使用，待日後更新時再移除。
 */
export const trackProductClickEvent = async (skuId) => {
  const tracker = await ensureTracker();
  if (!tracker) { return; }

  if (isNil(skuId)) { return; }

  const postId = findHandsUPPostId();
  if (isNil(postId)) { return; }

  const category = 'cms-product';
  const action = 'click';
  const name = `${postId}-${skuId}`;
  const value = 1;

  tracker.trackEvent(category, action, name, value);
};

export const trackHandsupProductClickEvent = trackProductClickEvent;

/** @type {(skuId: string | number) => Promise<void>} */
export const trackOneSevenProductClickEvent = async (skuId) => {
  const tracker = await ensureTracker();
  if (!tracker) { return; }

  if (isNil(skuId)) { return; }

  const streamId = findOneSevenStreamId();
  if (isNil(streamId)) { return; }

  const category = 'one-seven-shop-product';
  const action = 'click';
  const name = `${streamId}-${skuId}`;
  const value = 1;

  tracker.trackEvent(category, action, name, value);
};

/** 
 * 17Shop 購物車埋點
 * https://17media.atlassian.net/browse/HU-8469
 * @type {(
 *  categoryCount: number,
 *  action: 'view' | 'click',
 *  stepName: string,
 *  storeSlug: string,
 * ) => Promise<void>} 
 * */
export const trackOneSevenCheckoutFlowEvent = async (categoryCount, action, stepName, storeSlug) => {
  const tracker = await ensureTracker();
  if (!tracker) { return; }
  
  // 這邊的 categoryCount 是指分類數量，必須是正整數
  if (!Number.isInteger(categoryCount) || categoryCount <= 0) { 
    return; 
  }
  
  if (isNil(action) || (action !== 'view' && action !== 'click')) {
    return;
  }
  
  if (isNil(stepName) || isNil(storeSlug)) {
    return;
  }

  // 只有一個分類用 with-single-category，兩個以上用 with-multi-category
  const category = categoryCount === 1
    ? 'one-seven-shop-checkout-flow-with-single-category'
    : 'one-seven-shop-checkout-flow-with-multi-category';
  const name = `${stepName}|${storeSlug}`;

  tracker.trackEvent(category, action, name);
};

/** 
 * 設定追蹤器的 Cookie 域名
 * @typedef {Object} CookieDomainSetupOptions
 * @property {boolean} [trackPageView=true] - 是否在設定域名後追蹤頁面瀏覽，預設值為 true
 * @type {(domain: string, option?: CookieDomainSetupOptions) => Promise<void>} 
 */
export const setupCookieDomain = async (domain, option) => {
  const tracker = await ensureTracker();
  if (!tracker) { return; }
  
  if (isNil(domain) || typeof domain !== 'string' || domain.trim() === '') { return; }

  tracker.setCookieDomain(domain);

  const trackPageView = option?.trackPageView ?? true;
  if (trackPageView) {
    tracker.trackPageView();
  }
};
